import { BaseApi } from "./base-api";
import { setCMSCookies } from "./cookie-helper";
import { base } from "$app/paths";
export class UIApiBase extends BaseApi {
    constructor(headers, showlog = true) {
        super(headers, showlog);
    }
    afterResponse(response) {
        if (this.input) {
            setCMSCookies(response, this.input, { httpOnly: true, path: `${base || "/"}`, secure: true });
        }
    }
}
